export const LOCAL_STORAGE = "local-storage";
export const SESSION_STORAGE = "session-storage";

export const LS_DOMAIN_AND_LOCKER_BANK = "DnLB";
export const LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS = "TALBSet";
export const LS_TENANT_INFO = "TenIn";
export const LS_LOCKER_BANK_INFO = "LBIn";
export const LS_CUSTOMER = "CsMr";
export const LS_UNIQUE_DEVICE_ID = 'UDId';
export const LS_PAGE_FLOW = "PgFlw";
export const LS_GUEST_USER = "gUSR";
export const LS_SELECTED_LANGUAGE = "selectedLanguage";
export const LS_IS_REDIRECTED_FROM_STRIPE_PAYMENT_GATEWAY = "isRedF-StripePg";
export const LS_PROP_LOCKER_UNIT_DETAILS = "prop-LUDet";
export const LS_IS_OPEN_WITH_CHECKOUT_AFTER_OVERSTAY_PAYMENT = "isOwC-aOPay";
export const LB_LOCATION = "lBLocation";
export const LB_NAME = "lBCName";
export const TXN_ID = "txnId";
export const USER_INFO = "UIn";
export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';
export const ACCESS_TOKEN_EXPIRY_TIME = 'access_token_expiry_time';
export const REFRESH_TOKEN_EXPIRY_TIME = 'refresh_token_expiry_time';
export const OPERATION_ID = 'operation_id';
export const IS_LOGGED_IN = 'isLoggedIn';
export const PAYMENT_REFERENCE_ID = 'payment_reference_id';
export const PAYMENT_GATEWAY_REFERENCE ="payment_gateway_reference";
export const SELECTED_EQUPMNENT = 'selected_equipment';
export const SS_REDIRECTED_FROM_LOGIN = "redirected-from-login";
export const SS_PAYMENT_GATEWAY = 'PgWay';
export const SS_PAYMENT_GATEWAY_ACCESS_KEY = 'pGaKey';
export const CURRENT_SLOT = "current_slot";
export const DIFFERENTIAL = "differential";
export const HOURLY = "hourly";
export const LOWEST_PAYMENT = "lowest_payment";
export const LS_ASSIGNMENT_SLUG = 'asSlu';
export const LS_BANKID = 'bId';
export const LS_TRANSACTION_COMPLETED = 'transactionCompleted';
export const IS_OTP_SEND = "is_otp_sent";
export const LS_PHONE_PREFIX = "phonePrefix";
export const LS_PHONE_NUMBER_LENGTH = "phoneNumberLength";
export const LS_ALLOWED_LANGUAGE = "allowedLanguage";
export const LS_LOCAL_LANGUAGE = "localLanguage";
export const LS_BOOKING_TYPE= 'BookingType';
export const ADVANCE_BOOKING = 'advanceBooking';
export const BULK_BOOKING = 'bulkBooking';
export const LOCKER_SLUG = "locker_slug";
export const USER_DETAILS_DIALOG_SHOWN = 'USER_DETAILS_DIALOG_SHOWN';
export const STATEGST = 'isStateGST';
export const GUESS_TOKEN ="guess_token";
export const USER_LOCATION_DETAILS = "userlocationDetails";
export const LOCKER_BANK_ADDRESS = "locker_bank_address";
export const PERMISSIONS_LIST = "permissions_list";
export const ACCESS_GROUP_BANKS = "access_group_banks";

